export default __webpack_public_path__ + "static/media/book.4a106706.png";